import { DateFormat, formatDate, TimeFormat } from "@nova/format"
import { config } from "@nova/configuration/browser"
import {
    SATELLITE_SENSOR_TYPE_INFO,
    SATELLITE_TEMPORAL_BIAS_LABELS,
    SatelliteSensorType,
    SatelliteTemporalBias,
} from "@nova/constants"
import { SatelliteFlight } from "@nova/protobuf"
import { getDate } from "../module"

function MetadataRow({ label, value }: { label: string; value: string }) {
    return (
        <div className="flex items-center justify-between w-full">
            <small className="text-gray-100">{label}</small>
            <small className="mono text-gray-300">{value}</small>
        </div>
    )
}

export const SatelliteMetadataRows = ({ flight }: { flight: SatelliteFlight }) => {
    const { organizationSettingDateFormat, organizationSettingTimeFormat } = config.use(
        "organizationSettingDateFormat",
        "organizationSettingTimeFormat"
    )
    const dateFormat = organizationSettingDateFormat as DateFormat
    const timeFormat = organizationSettingTimeFormat as TimeFormat

    const sensorLabel =
        flight.sensorType !== undefined
            ? SATELLITE_SENSOR_TYPE_INFO[flight.sensorType as SatelliteSensorType].label
            : "-"
    const processingLabel =
        flight.cloudFree && flight.dehaze
            ? "Dehaze & CloudFree"
            : flight.cloudFree
              ? "CloudFree"
              : flight.dehaze
                ? "Dehaze"
                : "Standard"
    const dateCreated = getDate(flight.createdAt, dateFormat, timeFormat)
    const temporalBiasLabel = flight.temporalBias
        ? SATELLITE_TEMPORAL_BIAS_LABELS[flight.temporalBias as SatelliteTemporalBias]
        : undefined
    const targetDate = flight.temporalAnchor
        ? formatDate({ value: new Date(flight.temporalAnchor * 1000), format: dateFormat })
        : undefined

    return (
        <div className="flex flex-col gap-2">
            <MetadataRow label="Sensor" value={sensorLabel} />
            <MetadataRow label="Processing" value={processingLabel} />
            <MetadataRow label="Date Created" value={dateCreated || "-"} />
            {targetDate && (
                <MetadataRow
                    label="Target Date"
                    value={temporalBiasLabel ? `${temporalBiasLabel} ${targetDate}` : targetDate}
                />
            )}
        </div>
    )
}
